import React, { useState, useEffect, useCallback } from 'react';
import {
	NavLink,
	useLocation,
	useNavigate,
	useParams
} from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { Action, GET, GETWITH, LanguageContext, POST, publish, pushStateHistoryModal, QueryOrder, QueryParam, subscribe, TranslateContext, unsubscribe, useAuth, useNavigation, UserConfigContext, UserContext, useTranslateContext, useUserConfigContext, useUserContext, ycStorage } from 'fennec-ui';
import REDUX_Pari from '../../../objects/Pari/reducer';
import CRUDE_Pari from '../../../objects/Pari/crude';
import REDUX_UserConfig from '../../../objects/UserConfig/reducer'
import REDUX_Translate from '../../../objects/Translate/reducer';
import CRUDE_VseTipiPolzovatelei from '../../../objects/VseTipiPolzovatelei/crude'
import { errorCatch, QueryDetail, READWITH } from 'fennec-ui';
import REDUX_AkkauntiPolzovatelei from '../../../objects/AkkauntiPolzovatelei/reducer';
import { MetaContext } from 'fennec-ui';
import { MaxIcon, translate, ycBucket } from '../../../common/Tool';
import LangSwitchMobile from '../../components/LangSwitchMobile';
import { LangSwitchContext, useLangSwitchContext } from '../../../common/Context';
import ByIDResult from './ByIDResult';
import { Dialog } from '../../../common/Dialog';
import { Avatar, List, Popup } from 'antd-mobile';
import { LogoutOutlined } from '@ant-design/icons';
import Icofont from 'react-icofont';
import QRCode from 'react-qr-code';
import { Button } from 'antd';

var _ = require('lodash');

function Sidebar(props) {
	// const { open, setOpen } = props;
	const { open, menuClose } = props;
	let navigate = useNavigation();
	// const history = useHistory();
	// history.push("/home");
	const auth = useAuth();
	const t = useTranslateContext();
	const user = useUserContext();
	const langSwitch = useLangSwitchContext();
	const [userConfig, setUserConfig] = useUserConfigContext();
	const akkauntiPolzovatelei = useSelector(REDUX_AkkauntiPolzovatelei.selector.array);

	const vkbot = process.env.REACT_APP_VKBOT
	const tgbot = process.env.REACT_APP_TGBOT
	const maxbot = process.env.REACT_APP_MAXBOT

	// useEffect(() => {
	// 	setOpen(false)
	// }, [location.pathname]);

	const logout = () => {
		auth.logout(() => {
			navigate('/');
		});
	}
	const logoutall = (e) => {
		e.stopPropagation();
		e.preventDefault();

		Dialog.confirm({
			content: t('Вы действительно хотите выйти на всех устройствах?'),
			confirmText: t("Выйти"),
			cancelText: t("Отмена"),
			onConfirm: async () => {
				await auth.logoutall(() => {
					navigate('/');
				});
			},
		})
	}

	const [idCard, setIdCard] = useState()
	const loadIdCard = useCallback(() => {
		GET(auth, '/api/idcard', ({ data }) => {
			if (data) {
				setIdCard(data)
			}
		}, (err) => errorCatch(err))
	}, [auth])

	return (
		<Popup
			visible={open}
			// onMaskClick={() => setOpen(false)}
			onMaskClick={menuClose}
			position='right'
			bodyStyle={{ width: '80vw' }}
		>
			<div className='sidebar'>
				<div>
					{user && <div className='user bg bg-grey dark-5' style={{ padding: "4px" }}>
						<Avatar src={(user.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + user.avatarMin : ""} />
						<div className='user-name'>
							<div style={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "14px" }}>{user.lastname + " " + user.firstname}</div>
							<div style={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "12px", color: "#9a9a9ab5" }}>{user.email}</div>
						</div>
						<div>
							<Action
								auth={auth}
								action={() => {
								}}
								object={idCard}
								modal={{
									title: "QR-id"
								}}

								readonly={true}
								mode={"func"}
								noAntForm={true}
								form={(props) => {
									const { object } = props;
									return <div style={{ display: "flex", justifyContent: "center", padding: "5px" }}>
										{object &&
											<div>
												<div className='bg bg-transparent' style={{ display: "flex", justifyContent: "space-evenly" }}>
													<Avatar src={(user?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + user?.avatarMin : undefined} />

													<div className='user-name'>
														<div style={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "14px" }}>{user.lastname + " " + user.firstname}</div>
														<div style={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "12px", color: "#9a9a9ab5" }}>{user.email}</div>
													</div>
												</div>

												<div style={{ padding: "15px 5px 20px 5px", backgroundColor: "white", borderRadius: "6px", textAlign: "center" }}>
													<QRCode level="M" value={object} />
												</div>

												<div style={{ display: "flex", justifyContent: "center" }}>
													<Button onClick={loadIdCard}>Обновить</Button>
												</div>
											</div>}
									</div>
								}}
								trigger={(click) => (
									<div onClick={event => {
										event.stopPropagation();
										loadIdCard()
										click()
									}}>
										<i className="fa fa-qrcode" style={{ color: "black", fontSize: "42px", margin: "3px 5px 0 0" }}></i>
									</div>
								)}
							/>
						</div>
					</div>}
					<div className='logout bg bg-grey' style={{ padding: "4px", marginTop: "5px" }} onClick={logout}>
						<div>
							<LogoutOutlined />
							<span style={{ paddingLeft: "5px" }}> {t("Выход")}</span>
						</div>
						<div style={{ flex: 0, color: "red" }} onClick={logoutall}>
							<Icofont icon="logout" />
						</div>
					</div>
				</div>
				<div>
					{langSwitch}
				</div>
				<div>
					<div style={{ padding: "5px 0px", display: "flex", alignItems: "center", gap: "5px" }}>
						<div style={{ flex: "1 1 50%" }}>
							<a target="_blank" rel="noreferrer" href={(tgbot) ? 'https://t.me/' + tgbot : "#"}>
								<div className={`bg bg-grey light-10 pointer ${(user && user.tgchatid) ? "border-green" : "border-red"}`} style={{ justifyContent: "center", padding: "2px 4px", display: "flex", gap: "5px", alignItems: "center" }}>
									<div><i className="fa fa-telegram" style={{ fontSize: "14px" }}></i></div>
									<div style={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.85)" }}>
										{(user && !user.tgchatid) && <div>Telegram</div>}
										{(user && user.tgchatid) && <div>Telegram</div>}
									</div>
								</div>
							</a>
						</div>
						<div style={{ flex: "1 1 50%" }}>
							<a target="_blank" rel="noreferrer" href={(vkbot) ? 'https://vk.com/im?sel=-' + vkbot : "#"}>
								<div className={`bg bg-grey light-10 pointer ${(user && user.vk) ? "border-green" : "border-red"}`} style={{ justifyContent: "center", padding: "2px 4px", display: "flex", gap: "5px", alignItems: "center" }}>
									<div><i className="fa fa-vk" style={{ fontSize: "14px" }}></i></div>
									<div style={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.85)" }}>
										{(user && !user.vk) && <div>VK</div>}
										{(user && user.vk) && <div>VK</div>}
									</div>
								</div>
							</a>
						</div>
						<div style={{ flex: "1 1 50%" }}>
							<a target="_blank" rel="noreferrer" href={(maxbot) ? 'https://max.ru/' + maxbot : "#"}>
								<div className={`bg bg-grey light-10 pointer ${(user && user.maxchatid) ? "border-green" : "border-red"}`} style={{ justifyContent: "center", padding: "2px 4px", display: "flex", gap: "5px", alignItems: "center" }}>
									<div><MaxIcon width={14} height={14} color="#4096ff" /></div>
									<div style={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.85)" }}>
										{(user && !user.maxchatid) && <div>Max</div>}
										{(user && user.maxchatid) && <div>Max</div>}
									</div>
								</div>
							</a>
						</div>
					</div>
				</div>
				<div>
					{!!akkauntiPolzovatelei && <div className="bg bg-grey" style={{ padding: "5px 10px", textAlign: "left", marginBottom: "5px" }}>
						<div>Баланс:</div>
						{akkauntiPolzovatelei.map((e, idx) => <div key={idx} style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", fontSize: "13px" }}>
							<div>
								№{e.akkaunt.nomerAkkaunta}
							</div>
							<div style={{ flex: "auto", textAlign: "end", paddingLeft: "15px", color: (e.akkaunt.ostatok > 0) ? "green" : "red" }}>
								{Number(e.akkaunt.ostatok.toFixed(2)).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
							</div>
						</div>)}
					</div>}
					<div style={{ padding: "0px 0px" }}>
						<List>
							<List.Item
								prefix={<i className="fa fa-globe" style={{ paddingRight: "4px", color: "blue" }}></i>}
								className={"bg-blue"}>
								<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/fed/events`}>
									{t("Главный сайт")}
								</a>
							</List.Item>
							<List.Item
								prefix={<Icofont icon="home" style={{ fontSize: "13px", color: "orange" }} />}
								className={"bg-orange"}>
								<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app`}>
									{t("Личный кабинет")}
								</a>
							</List.Item>
							<List.Item
								prefix={<Icofont icon="ui-calendar" style={{ fontSize: "13px", color: "green" }} />}
								className={"bg-green"}>
								<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/switch`}>
									{t("Войти в мероприятие")}
								</a>
							</List.Item>
							<List.Item
								prefix={<Icofont icon="user" style={{ fontSize: "13px" }} />}>
								<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://auth.${auth.getDomainWithoutSubdomain(window.location.href)}/common/profile`}>
									{t("Профиль")}
								</a>
							</List.Item>
						</List>
					</div>
				</div>
			</div>
		</Popup>
	);
}

function EventResult(props) {
	let navigate = useNavigate();
	const langSwitch = useLangSwitchContext();
	const auth = useAuth();
	const dispatch = useDispatch();
	const userConfig = useSelector(REDUX_UserConfig.selector.object) || {};
	const translates = useSelector(REDUX_Translate.selector.object);
	const [language, setLanguage] = useState({ lang: (auth.getCookie("lang") || "ru") })
	const t = React.useMemo(() => _.bind(translate, {
		translate: translates,
		config: language
	}), [translates, language]);
	// const t = useTranslateContext();
	// console.log(t("да"));

	const meta = useSelector(state => state.meta);
	const user = useSelector(state => state.home.user);
	const role_by_id = useSelector(state => state.home.role_by_id);
	const status = useSelector(state => state.home.status);
	const notify = useSelector(state => state.home.notify);

	const setUserConfig = (name, value, onChange) => {
		POST(auth, "/api/setuserconfig", {
			key: name,
			value: value
		}, ({ data }) => {
			var arr = [data];
			var obj = Object.fromEntries(arr.map(i => {
				return [
					i.key,
					i.value
				]
			}));
			let i = { ...userConfig, ...obj };
			let o = REDUX_UserConfig.actions.setObject(i);
			dispatch(o);
			if (onChange) {
				onChange(i);
			}
		}, errorCatch);
	};

	const [online, setOnline] = useState(false);
	const location = useLocation();
	useEffect(() => {
		const currentPath = location.pathname;
		dispatch({ type: "PATH", payload: currentPath.replace(/\/$/, "") });
	}, [location]);
	useEffect(
		() => {
			_subscribe();
			return () => {
				_unsubscribe();
			};
		},
		[ /* TODO: memoization parameters here */]
	);

	const _RefreshAkkaunti = () => {
		READWITH(auth, "AkkauntiPolzovatelei", [
			QueryDetail("model")
		], ({ data }) => {
			if (data) {
				dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray(data));
			}
		}, errorCatch);
	};
	var RefreshAkkaunti = _.throttle(_RefreshAkkaunti, 3000, { 'trailing': false });

	const uuid = "53f2ffd3d9a5";
	useEffect(() => {
		let token = subscribe("service.status", function (msg, data) {
			if (msg.startsWith(`service.status.${uuid}`)) {
				return
			}
			dispatch({ type: 'STATUS-UPDATE', payload: data })
		});
		return () => {
			unsubscribe(token);
		};
	}, [])
	useEffect(() => {
		let token = subscribe("service.notify", function (msg, data) {
			if (msg.startsWith(`service.notify.${uuid}`)) {
				return
			}
			dispatch({ type: 'NOTIFY-UPDATE', payload: data })
		});
		return () => {
			unsubscribe(token);
		};
	}, [])
	const _subscribe = () => {
		auth.fetch('/api/meta').then(res => {
			if (res && res.data && dispatch) {
				dispatch({ type: 'META', payload: res.data })
			}
		});
		auth.fetch('/api/iam').then(res => {
			if (res && res.data) {
				dispatch({ type: 'USER', payload: res.data })
			}
		});
		READWITH(auth, 'Translate', [
			QueryDetail("model")
		], ({ data }) => {
			if (data.length > 0) {
				let o = Object.fromEntries(data.map(i => {
					return [
						i.key,
						{
							ru: i.ru,
							en: i.en,
							es: i.es,
							tr: i.tr,
						},
					]
				}));
				dispatch(REDUX_Translate.actions.setObject(o));
			}
		}, errorCatch)
		READWITH(auth, 'UserConfig', [
			QueryDetail("model")
		], ({ data }) => {
			if (data.length > 0) {
				var obj = Object.fromEntries(data.map(i => {
					return [
						i.key,
						i.value
					]
				}));
				dispatch(REDUX_UserConfig.actions.setObject(obj));
			}
		}, errorCatch)
		RefreshAkkaunti();
		CRUDE_VseTipiPolzovatelei.read(auth, (data) => {
			if (data.length > 0) {
				// dispatch(REDUX_VseTipiPolzovatelei.actions.setArray(data));
				dispatch({ type: 'ROLE', payload: data });
			}
		}, 'model', 's-id=ASC');
		auth.openSocket("/ws/service", "service",
			//onmessage
			function (type, payload) {
				if (type === "reload") {
					window.location.href = window.location.href;
				}
				switch (type) {
					case "siteaccess":
						dispatch({ type: "SITE_ACCESS", payload: payload });
						break;
					case "role":
						dispatch({ type: 'ROLE-UPDATE', payload: [payload] })
						break;
					case "status":
						publish(`service.${type}.${uuid}`, [payload]);
						dispatch({ type: 'STATUS-UPDATE', payload: [payload] })
						break;
					case "notify":
						publish(`service.${type}.${uuid}`, [payload]);
						dispatch({ type: 'NOTIFY-UPDATE', payload: [payload] })
						break;
					case "predlozhenierukiiserdtsa":
						dispatch(REDUX_Pari.actions.updateArray([payload]));
						break;
					case "polozhitelniiotvetnapredlozhenierukiiserdtsa":
						dispatch(REDUX_Pari.actions.updateArray([payload]));
						break;
					case "AkkauntiPolzovatelei":
						dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray([payload]));
						break;
					case "NeedUpdateAkkauntPolzovatelya":
						RefreshAkkaunti();
						break;
					default:
						publish("service." + type, payload);
						break;
				}
			},
			//onopen
			function () {
				setOnline(true);
			},
			//onclose
			function () {
				setOnline(false);
			}
		);

		GETWITH(auth, '/api/query/InterfeisiInfrastrukturnikhStatusov', [
			QueryDetail("model"),
			QueryOrder("status.DataPoslednegoIzmeneniya", "DESC"),
			QueryParam("w-TipNovayaInfa", "true"),
			QueryParam("w-status.Arkhiv", "false")
		],
			({ data }) => {
				dispatch({ type: 'STATUS', payload: data })
			}, errorCatch);
		GETWITH(auth, '/api/query/InfrastrukturnieUvedomleniya', [
			QueryDetail("model"),
			QueryOrder("Data", "DESC"),
			QueryParam("w-eqOrNu-Prochitano", "false"),
		], ({ data }) => {
			dispatch({ type: 'NOTIFY', payload: data })
		}, errorCatch);
		CRUDE_Pari.read(auth, (data) => {
			if (data.length > 0) {
				dispatch(REDUX_Pari.actions.setArray(data?.filter(item => !item.dokumentVikhodaID)));
			}
		}, 'model', 's-id=ASC');
	};
	const _unsubscribe = () => {
		auth.closeSocket("service");
	};
	const logout = () => {
		auth.logout(() => {
			navigate('/app');
		});
	}

	const [open, setOpen] = useState(false);
	const menuClose = () => {
		if (open) {
			window.history.back();
		}
	}
	const onOpenChange = () => {
		if (!open) {
			pushStateHistoryModal(setOpen, getStack);
			setOpen(true);
			return
		}
		menuClose();
	}
	const stack = [];
	const getStack = React.useCallback(() => {
		return stack;
	}, []);

	let { id } = useParams();


	return (
		<TranslateContext.Provider value={t}>
			<MetaContext.Provider value={meta}>
				<UserContext.Provider value={user}>
					<UserConfigContext.Provider value={[userConfig, setUserConfig]}>
						<LanguageContext.Provider value={[language, setLanguage]}>
							<LangSwitchContext.Provider value={<LangSwitchMobile userConfig={userConfig} />}>
								<div className='app'>
									<div className='header' style={{ display: "flex", justifyContent: "space-between", backgroundColor: "white"/*"#001529"*/ }}>
										<NavLink to="/fed/events">
											<div style={{ flex: 0 }}>
												{/* <div className="logo-mobile" /> */}
												<div className="logo-mobile-blue" />
											</div>
										</NavLink>
										<div style={{ flex: 0 }}>
											<div className='sider-button' style={{ color: "#555" }}>
												<Icofont key="1" icon="navigation-menu" onClick={onOpenChange} />
											</div>
										</div>
									</div>
									<div className='content'>
										<Sidebar open={open} menuClose={menuClose} getStack={getStack} />
										<div className='page'>
											<ByIDResult />
										</div>
									</div>
								</div>
							</LangSwitchContext.Provider>
						</LanguageContext.Provider>
					</UserConfigContext.Provider>
				</UserContext.Provider>
			</MetaContext.Provider>
		</TranslateContext.Provider>
	);
};

export default EventResult;